(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__lnSignupPopup) return;
  window.__lnSignupPopup = true;

  var designMode = window.Shopify && window.Shopify.designMode;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var scrollState = { previous: window.scrollY, direction: 'down' };

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : undefined;
  }

  function setCookie(name, value, days) {
    var expires = '';
    var lifetime = parseInt(days, 10);
    if (lifetime) {
      var date = new Date();
      date.setDate(date.getDate() + lifetime);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/';
  }

  function getScrollPercent() {
    var h = document.documentElement;
    var b = document.body;
    var scrollTop = h.scrollTop || b.scrollTop;
    var height = (h.scrollHeight || b.scrollHeight) - h.clientHeight;
    if (!height) return 0;
    return (scrollTop / height) * 100;
  }

  function popupFrom(target) {
    if (!target) return null;
    if (target.classList && target.classList.contains('popup')) return target;
    return target.closest ? target.closest('.popup') : null;
  }

  function isAllowed(popup) {
    var limit = parseInt(popup.dataset.limitDisplay || '0', 10);
    var seen = parseInt(getCookie('popup-' + popup.dataset.id) || '0', 10);
    if (limit && seen && seen >= limit) return false;
    return true;
  }

  function applyAnimation(popup, name, callback) {
    var overlayName = typeof callback === 'function' ? 'lnPopupExitFade' : 'lnPopupOpenFade';
    var overlay = popup.nextElementSibling;
    if (overlay && overlay.classList.contains('popup-overlay')) {
      overlay.classList.add('popup-animated', overlayName);
      overlay.addEventListener('animationend', function () {
        overlay.classList.remove('popup-animated', overlayName);
      }, { once: true });
    }

    var wrap = popup.querySelector('.popup-wrap');
    if (!wrap || !name || reduceMotion) {
      if (typeof callback === 'function') callback();
      return;
    }

    wrap.classList.add('popup-animated', name);
    var finished = false;
    var done = function () {
      if (finished) return;
      finished = true;
      wrap.classList.remove('popup-animated', name);
      if (typeof callback === 'function') callback();
    };
    wrap.addEventListener('animationend', done, { once: true });
    window.setTimeout(done, 700);
  }

  function openPopup(target) {
    var popup = popupFrom(target);
    if (!popup || !popup.isConnected) return;
    if (popup.classList.contains('popup-open') || popup.classList.contains('popup-already-opened')) return;

    if (popup.dataset.bodyScrollDisable === 'true') {
      document.body.classList.add('ln-popup-scroll-hidden');
    }

    if (!designMode) {
      var seen = parseInt(getCookie('popup-' + popup.dataset.id) || '0', 10) + 1;
      setCookie('popup-' + popup.dataset.id, seen, popup.dataset.limitLifetime);
    }

    popup.classList.add('popup-open');
    popup.dataset.initScrollPx = String(window.scrollY);
    popup.dataset.initScrollPercent = String(getScrollPercent());
    applyAnimation(popup, popup.dataset.openAnimation);
    closeTrigger(popup);

    var closeButton = popup.querySelector('.popup-close');
    if (closeButton) closeButton.focus();
  }

  function closePopup(target) {
    var popup = popupFrom(target);
    if (!popup || !popup.classList.contains('popup-open')) return;

    applyAnimation(popup, popup.dataset.exitAnimation, function () {
      popup.classList.add('popup-already-opened');
      popup.classList.remove('popup-open');
    });
    document.body.classList.remove('ln-popup-scroll-hidden');
  }

  function closeTrigger(popup) {
    if (popup.dataset.closeBound === 'true') return;
    popup.dataset.closeBound = 'true';

    var trigger = popup.dataset.closeTrigger;
    if (trigger === 'delay') {
      window.setTimeout(function () {
        closePopup(popup);
      }, (parseFloat(popup.dataset.closeDelayNumber) || 0) * 1000);
    }

    if (trigger === 'scroll') {
      document.addEventListener('scroll', function () {
        var type = popup.dataset.closeScrollType;
        var position = parseFloat(popup.dataset.closeScrollPosition) || 0;
        var startPx = parseFloat(popup.dataset.initScrollPx) || 0;
        var startPercent = parseFloat(popup.dataset.initScrollPercent) || 0;

        if (type === 'px') {
          if (scrollState.direction === 'up' && window.scrollY < startPx - position) closePopup(popup);
          if (scrollState.direction === 'down' && window.scrollY >= startPx + position) closePopup(popup);
        }
        if (type === '%') {
          var current = getScrollPercent();
          if (scrollState.direction === 'up' && current < startPercent - position) closePopup(popup);
          if (scrollState.direction === 'down' && current >= startPercent + position) closePopup(popup);
        }
      }, { passive: true });
    }
  }

  function openTrigger(popup) {
    var trigger = popup.dataset.openTrigger;

    if (trigger === 'delay') {
      window.setTimeout(function () {
        openPopup(popup);
      }, (parseFloat(popup.dataset.openDelayNumber) || 0) * 1000);
    }

    if (trigger === 'exit') {
      var armed = true;
      document.addEventListener('mousemove', function (event) {
        var scroll = window.pageYOffset || document.documentElement.scrollTop;
        if (armed && event.pageY - scroll < 7) {
          armed = false;
          openPopup(popup);
        }
      });
    }

    if (trigger === 'scroll') {
      var type = popup.dataset.openScrollType;
      var position = parseFloat(popup.dataset.openScrollPosition) || 0;
      var onScroll = function () {
        if (type === 'px' && window.scrollY >= position) openPopup(popup);
        if (type === '%' && getScrollPercent() >= position) openPopup(popup);
      };
      document.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    if (trigger === 'manual') {
      var selector = popup.dataset.openManualSelector;
      if (!selector) return;
      document.querySelectorAll(selector).forEach(function (node) {
        node.classList.add('ln-popup-trigger');
      });
      document.addEventListener('click', function (event) {
        var triggerNode = event.target.closest(selector);
        if (!triggerNode) return;
        event.preventDefault();
        popup.classList.remove('popup-already-opened');
        openPopup(popup);
      });
    }
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.ln-popup-root .popup').forEach(function (popup) {
      if (popup.dataset.lnReady === 'true') return;
      popup.dataset.lnReady = 'true';

      if (designMode || popup.dataset.forceOpen === 'true') {
        popup.classList.remove('popup-already-opened');
        openPopup(popup);
        return;
      }

      if (!isAllowed(popup)) return;
      openTrigger(popup);
    });
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('.popup-close')) {
      event.preventDefault();
      closePopup(event.target);
      return;
    }
    if (event.target.closest('.ln-popup-root .popup-overlay')) {
      document.querySelectorAll('.ln-popup-root .popup-open[data-overlay-close="true"]').forEach(closePopup);
    }
  });

  document.addEventListener('keyup', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.ln-popup-root .popup-open[data-esc-close="true"]').forEach(closePopup);
  });

  document.addEventListener('scroll', function () {
    var current = window.scrollY;
    scrollState.direction = current > scrollState.previous ? 'down' : 'up';
    scrollState.previous = current;
  }, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
